var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"json-editor-container"},[_c('textarea',{attrs:{"placeholder":_vm.placeholder,"spellcheck":"false"},domProps:{"value":_vm._f("json")(_vm.content)},on:{"input":function($event){return _vm.parseJSON($event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }